import { z } from 'zod';
import { BaseResponseSchema, containerSizeSchema, containerStatusSchema, containerTypeSchema, dateSchema, emailSchema, firstNameSchema, integerIdSchema, lastNameSchema, nullableIntegerIdSchema, phoneNumberSchema, waferFingerprintSchema, waferMaterialTypeSchema, waferPatternTypeSchema, waferSizeSchema, waferStatusSchema, waferThicknessTypeSchema, } from './primitives.js';
import { FileMetadataSchema } from './files.schemas.js';
import { LearnedLightingModeEntrySchema } from '../efem-wafer-imaging.schemas.js';
export const WaferEfemMetadataSchema = z.object({
    learnedLightingModes: z.array(LearnedLightingModeEntrySchema).optional(),
    learnedLightingAt: z.string().optional(),
    learnedLightingFromCameraSerial: z.string().optional(),
    learnedLightingFromJobId: z.string().optional(),
});
export const EntityFilesDeleteResponseDataSchema = z.object({
    deletedCount: z.number().int().nonnegative(),
    objectKeys: z.array(z.string()),
});
// Response and Pagination Schemas
export const PaginatedResponseSchema = z.object({
    data: z.array(z.any()),
    pagination: z.object({
        page: z.number(),
        limit: z.number(),
        total: z.number(),
        totalPages: z.number()
    })
});
// Specialized Response Schemas
export const WaferResponseSchema = z.object({
    id: integerIdSchema,
    type: waferPatternTypeSchema,
    size: waferSizeSchema,
    layerName: z.string(),
    companyAlias: z.string(),
    ownerFirstName: firstNameSchema.optional(),
    ownerLastName: lastNameSchema.optional(),
    ownerEmail: emailSchema,
    ownerPhone: phoneNumberSchema.optional().nullable(),
    ownerContactVersionId: z.string(),
    receivedDate: dateSchema,
    material: waferMaterialTypeSchema.optional(),
    thickness: waferThicknessTypeSchema.optional(),
    companyName: z.string().optional(),
    groupIds: z.array(integerIdSchema).optional(),
    returnedDate: dateSchema.optional().nullable(),
    status: waferStatusSchema,
    shippedDate: dateSchema.optional().nullable(),
    images: z.array(FileMetadataSchema).optional(),
    files: z.array(FileMetadataSchema).optional(),
    fingerprint: waferFingerprintSchema.optional().nullable(),
    fingerprintImages: z.array(FileMetadataSchema).optional(),
    containerId: nullableIntegerIdSchema.optional(),
    slotNumber: z.number().int().min(1).nullable().optional(),
    lotId: z.string().optional().nullable(),
    unlocatedAt: dateSchema.optional().nullable(),
    unlocatedFromContainerId: nullableIntegerIdSchema.optional(),
    unlocatedFromSlot: z.number().int().min(1).nullable().optional(),
    sourceConflictId: nullableIntegerIdSchema.optional(),
    container: z.any().optional(),
    storageUsedBytes: z.coerce.number().optional(),
    createdAt: dateSchema,
    updatedAt: dateSchema,
    createdBy: nullableIntegerIdSchema.optional(),
    updatedBy: nullableIntegerIdSchema.optional(),
    metadata: WaferEfemMetadataSchema.optional().nullable(),
});
export const GetWafersResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        wafers: z.array(WaferResponseSchema),
        total: z.number().int(),
        page: z.number().int(),
        limit: z.number().int(),
        totalPages: z.number().int()
    })
});
export const ContainerResponseSchema = z.object({
    id: integerIdSchema,
    type: containerTypeSchema,
    containerName: z.string(),
    containerBarcode: z.string().nullable().optional(),
    size: containerSizeSchema,
    companyAlias: z.string(),
    ownerFirstName: firstNameSchema.optional().nullable(),
    ownerLastName: lastNameSchema.optional().nullable(),
    ownerEmail: emailSchema,
    ownerPhone: phoneNumberSchema.optional().nullable(),
    ownerContactVersionId: z.string(),
    receivedDate: dateSchema,
    companyName: z.string().optional(),
    groupIds: z.array(integerIdSchema).optional(),
    returnedDate: dateSchema.optional().nullable(),
    status: containerStatusSchema,
    shippedDate: dateSchema.optional().nullable(),
    images: z.array(FileMetadataSchema).optional(),
    files: z.array(FileMetadataSchema).optional(),
    beaconId: z.string().optional().nullable(),
    beaconVersion: z.number().optional(),
    maxSlots: z.number(),
    waferCount: z.number(),
    storageUsedBytes: z.coerce.number(),
    wafers: z.array(z.any()).optional(),
    createdAt: dateSchema,
    updatedAt: dateSchema,
    createdBy: nullableIntegerIdSchema.optional(),
    updatedBy: nullableIntegerIdSchema.optional(),
});
export const GetContainersResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        containers: z.array(ContainerResponseSchema),
        total: z.number().int(),
        page: z.number().int(),
        limit: z.number().int(),
        totalPages: z.number().int()
    })
});
export const CreateContainerResponseSchema = BaseResponseSchema.extend({
    data: ContainerResponseSchema
});
export const GetContainerByIdResponseSchema = BaseResponseSchema.extend({
    data: ContainerResponseSchema
});
export const UpdateContainerResponseSchema = BaseResponseSchema.extend({
    data: ContainerResponseSchema
});
export { ContainerSlotsResponseSchema } from './container-slot-map.schemas.js';
export const DeleteContainerFilesResponseSchema = BaseResponseSchema.extend({
    data: EntityFilesDeleteResponseDataSchema,
});
//# sourceMappingURL=tenant-entity-responses.schemas.js.map